import React from 'react';

export default function Tank37Icon({
  width = 64,
  height = 104,
  startColor = '#1E1E1E',
  midColor = '#EBEBEB',
  endColor = '#1E1E1E'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 69.257 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_FrontLegs">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="2.1396" y1="109.1211" x2="5.4053" y2="109.1211">
		<stop offset="0" style={{stopColor: "#4C4C4C"}} />
		<stop offset="0.52" style={{stopColor: "#B1B1B1"}} />
		<stop offset="1" style={{stopColor: "#656565"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M2.14,106.531h3.266v5.181H2.14V106.531z" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="63.8511" y1="109.1211" x2="67.3423" y2="109.1211">
		<stop offset="0" style={{stopColor: "#4C4C4C"}} />
		<stop offset="0.52" style={{stopColor: "#B1B1B1"}} />
		<stop offset="1" style={{stopColor: "#656565"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M63.851,106.531h3.491v5.181h-3.491V106.531z" />
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="0" y1="112.1055" x2="7.5449" y2="112.1055">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M0,112.5h7.545v-0.788H0V112.5z" />
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="61.8237" y1="112.1055" x2="69.2573" y2="112.1055">
		<stop offset="0" style={{stopColor: "#4C4C4C"}} />
		<stop offset="0.52" style={{stopColor: "#B1B1B1"}} />
		<stop offset="1" style={{stopColor: "#656565"}} />
	</linearGradient>
	<path fill={`url(#${id}_4_)`} d="M61.824,112.5h7.434v-0.788h-7.434V112.5z" />
</g>
<g id="Group_Support">
	<path fill="#4B4B4B" d="M10.811,2.703h47.635v5.856H10.811V2.703z" />
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="1.4639" y1="100.1133" x2="67.7925" y2="100.1133">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_5_)`} d="M1.464,106.757l16.441,1.014h16.779h16.554l16.554-1.014V92.455H1.464V106.757z" />
</g>
<g id="Group_Tank_Top">
	<linearGradient id={`${id}_6_`} gradientUnits="userSpaceOnUse" x1="34.6279" y1="3.1533" x2="34.6279" y2="11.2612">
		<stop offset="0" style={{stopColor: "#C7C7C7"}} />
		<stop offset="0.29" style={{stopColor: "#B0B0B0"}} />
		<stop offset="0.91" style={{stopColor: "#747474"}} />
		<stop offset="1" style={{stopColor: "#6B6B6B"}} />
	</linearGradient>
	<path fill={`url(#${id}_6_)`} d="M4.167,11.261H65.09V9.347c0,0-17.005-6.193-30.406-6.193c-14.246,0-30.518,6.193-30.518,6.193   V11.261z" />
	<path fill="#7E7E7E" d="M27.14,11.261h14.977V3.378c0,0-2.488-3.378-7.432-3.378c-4.806,0-7.545,3.378-7.545,3.378V11.261z" />
</g>
<g id="Group_TankBody">
	<linearGradient id={`${id}_7_`} gradientUnits="userSpaceOnUse" x1="4.1665" y1="51.8584" x2="65.0903" y2="51.8584">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_7_)`} d="M4.167,11.261H65.09v81.194H4.167V11.261" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M4.167,92.455V11.261" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M64.978,11.261v81.194" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M63.063,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M58.896,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M54.955,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M50.789,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M46.847,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M42.568,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M38.739,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M34.685,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M30.518,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M26.577,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M22.41,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M18.468,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M14.302,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M10.248,11.824v80.631" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M6.081,11.824v80.631" />
	<linearGradient id={`${id}_8_`} gradientUnits="userSpaceOnUse" x1="4.1665" y1="9.9102" x2="65.0903" y2="9.9102">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_8_)`} d="M4.167,11.261H65.09V8.559H4.167V11.261z" />
	<path fill="#616161" d="M4.617,11.261h2.027V12.5H4.617V11.261z" />
	<path fill="#616161" d="M60.135,11.261h2.026V12.5h-2.026V11.261z" />
	<path fill="#616161" d="M33.784,11.261h1.689V12.5h-1.689V11.261z" />
	<path fill="#616161" d="M47.072,11.261h1.689V12.5h-1.689V11.261z" />
	<path fill="#616161" d="M19.482,11.261h1.915V12.5h-1.915V11.261z" />
</g>
<g id="Group_Label">
	<path fill="#EFEFEF" d="M17.905,41.667h33.333V50H17.905V41.667z" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M19.482,43.581h9.122" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M32.771,43.581h15.315" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M37.725,45.383H49.55" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M31.532,47.522h18.243" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M33.784,45.383h-14.64" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M27.59,47.522h-8.108" />
</g>
    
      </g>
      <rect x="0" y="0" width="69.257" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
